<template>
  <v-navigation-drawer
    app
    :mini-variant.sync="mini"
    class="new-sidebar custom-scrollbar"
    :class="[
      mini
        ? me.role === 'FOUR_NETWORK'
          ? 'green100'
          : me.role === 'MARKETING'
          ? 'gray90'
          : 'purple100'
        : 'white',
      isTransitioning ? 'new-sidebar--transitioning' : '',
    ]"
    :width="355"
    v-model="drawer"
    style="z-index: 99"
    mini-variant-width="56"
    :permanent="$vuetify.breakpoint.lgAndUp"
    :temporary="$vuetify.breakpoint.mdAndDown"
    clipped
    v-if="me.role.length > 0"
  >
    <div v-if="isTransitioning" class="sidebar-transition-overlay" />
    <v-row
      :class="
        me.role === 'FOUR_NETWORK' || me.role === 'MARKETING'
          ? classHeader
          : mini
          ? ''
          : 'new-sidebar__content'
      "
    >
      <v-col cols="auto" v-if="mini" class="pb-6 px-4 pt-4">
        <SvgIcon
          name="exclusive_lounge"
          :color="me.role === 'FOUR_NETWORK' ? 'white' : 'gray50'"
          class="mr-2"
        />
      </v-col>
      <v-col v-if="!mini" cols="9" class="py-4 mx-4 d-flex align-center">
        <SvgIcon
          name="exclusive_lounge"
          color="white"
          class="mr-4"
          v-if="me.role === 'FOUR_NETWORK' || me.role === 'MARKETING'"
        />
        <img
          src="@/assets/admin_sidebar.svg"
          v-if="me.role === 'FOUR_NETWORK' && !mini"
          @click="redirectTimeline"
          class="cursor-pointer"
        />
        <img
          src="@/assets/business_sidebar.svg"
          v-if="me.role === 'MARKETING' && !mini"
          @click="redirectTimeline"
          class="cursor-pointer"
        />
        <!-- <img
          src="@/assets/logo_exclusive_lounge_toolbar.svg"
          v-if="
            me.role !== 'FOUR_NETWORK' &&
            me.role !== 'MARKETING' &&
            $vuetify.breakpoint.mdAndDown
          "
          @click="redirectTimeline"
          class="cursor-pointer"
        /> -->
        <img
          src="@/assets/exclusiveLounge.svg"
          v-if="me.role !== 'FOUR_NETWORK' && me.role !== 'MARKETING' && !mini"
          @click="redirectTimeline"
          class="cursor-pointer"
        />
      </v-col>
      <v-col
        :cols="mini ? 12 : 'auto'"
        class="d-flex align-center"
        :class="mini ? 'py-2 justify-center' : 'pb-4 pl-2'"
      >
        <BaseButton
          class="sidebar-toggle-btn"
          :type-button="
            mini || me.role === 'FOUR_NETWORK' || me.role === 'MARKETING'
              ? 'secondary'
              : !mini && me.role !== 'FOUR_NETWORK' && me.role !== 'MARKETING'
              ? 'primary'
              : 'tertiary'
          "
          :svg-icon-name="mini ? 'arrow_right' : 'arrow_left'"
          @click="miniSidebar"
          v-if="$vuetify.breakpoint.lgAndUp"
        />
        <BaseButton
          class="sidebar-toggle-btn"
          type-button="tertiary"
          svg-icon-name="arrow_left"
          @click="drawer = false"
          v-else
        />
      </v-col>
    </v-row>
    <v-row class="base-div pa-4" :class="''">
      <v-col cols="auto" v-if="mini">
        <SvgIcon
          name="search"
          :color="
            me.role === 'FOUR_NETWORK'
              ? 'white'
              : me.role === 'MARKETING'
              ? 'gray50'
              : $route.name === 'searchHome'
              ? 'white'
              : 'gray50'
          "
          @click="redirectSearch"
        />
      </v-col>
      <v-col cols="12" v-if="!mini">
        <BaseFilter
          v-model="filter"
          :placeholder="$t('search.placeholder')"
          @keyup.enter="updateStoreFilter"
          @click="redirectSearch"
          @click:append-outer="updateStoreFilter"
          @click:clear="clearStoreFilter"
          :is-auto-focus="$route.name === 'searchHome'"
          :is-sidebar="false"
        />
      </v-col>
    </v-row>
    <v-row
      class="pt-3 new-sidebar__cursor"
      v-if="currentUser.profileImage"
      :class="
        me.role === 'FOUR_NETWORK' || me.role === 'MARKETING'
          ? !mini
            ? ruleProfile
              ? 'px-4 purple100'
              : 'px-4 gray15'
            : ruleProfile
            ? 'pl-2 pr-1 purple100'
            : 'pl-2 pr-1'
          : !mini
          ? $route.name === 'profileHome'
            ? 'px-4 purple100'
            : 'px-4 gray15'
          : $route.name === 'profileHome'
          ? 'pl-2 pr-1 purpleSidebar'
          : 'pl-2 pr-1'
      "
      @click="redirectProfile"
    >
      <v-col cols="11">
        <UserPost
          :item="currentUser"
          :hide-button="true"
          :is-sidebar="true"
          :mini-sidebar="mini"
        />
      </v-col>
      <!-- <v-col cols="1">
        <BaseButton
          type-button="tertiary"
          svg-icon-name="arrow_right"
          class="sidebar-toggle-btn"
          :is-dark-context="ruleProfile || $route.name === 'profileHome'"
        />
      </v-col> -->
    </v-row>
    <v-list dense>
      <v-list-item
        :key="key"
        v-for="(item, key) of generalItems"
        :class="classMiniSidebar"
      >
        <v-row>
          <v-col cols="12" class="py-1">
            <NewSidebarItem
              :mini="mini"
              :item="item"
              @click="updateSelectedItem(item)"
              :class="backgroundSelectedItem(item)"
              :selected="isSeletecItem(item)"
              :is-notification="isNotification"
              :is-message-notification="isMessageNotification"
              :is-admin="me.role === 'FOUR_NETWORK'"
              :is-user="me.role !== 'FOUR_NETWORK' && me.role !== 'MARKETING'"
            />
          </v-col>
        </v-row>
      </v-list-item>
    </v-list>
    <v-col
      cols="12"
      v-if="
        metricsItems.length > 0 ||
        moderationItems.length > 0 ||
        userItems.length > 0 ||
        advertItems.length > 0
      "
    >
      <v-divider />
    </v-col>
    <v-list dense v-if="metricsItems.length > 0">
      <v-list-item :class="classMiniSidebar">
        <v-row
          @click="changeExpanded('metrics')"
          class="new-sidebar__cursor pr-4"
        >
          <v-col cols="11" class="py-0 d-flex align-center">
            <NewSidebarItem
              :mini="mini"
              :item="metricsHeader"
              :is-fixed="true"
              class="black--text"
              :class="colorBackground"
              :is-admin="me.role === 'FOUR_NETWORK'"
            />
          </v-col>
          <v-col cols="1">
            <BaseButton
              type-button="tertiary"
              :svg-icon-name="isExpandedItem(metricsExpanded)"
              class="sidebar-toggle-btn"
            />
          </v-col>
        </v-row>
      </v-list-item>
      <div v-if="metricsExpanded">
        <v-list-item
          :key="key"
          v-for="(item, key) of metricsItems"
          :class="classMiniSidebar"
        >
          <v-row>
            <v-col cols="12" class="py-0">
              <NewSidebarItem
                :mini="mini"
                :item="item"
                @click="updateSelectedItem(item)"
                :class="backgroundSelectedItem(item)"
                :selected="isSeletecItem(item)"
                :is-notification="isNotification"
                :is-message-notification="isMessageNotification"
                :is-image="false"
                :is-admin="me.role === 'FOUR_NETWORK'"
              />
            </v-col>
          </v-row>
        </v-list-item>
      </div>
    </v-list>
    <v-col
      :cols="mini ? '12' : '11'"
      :class="mini ? '' : 'mx-4'"
      v-if="
        me.role === 'FOUR_NETWORK' &&
        moderationItems.length > 0 &&
        metricsItems.length > 0
      "
    >
      <v-divider />
    </v-col>
    <v-list
      dense
      v-if="me.role === 'FOUR_NETWORK' && moderationItems.length > 0"
    >
      <v-list-item :class="classMiniSidebar">
        <v-row
          @click="changeExpanded('moderation')"
          class="new-sidebar__cursor pr-4"
        >
          <v-col cols="11" class="py-0 d-flex align-center">
            <NewSidebarItem
              :mini="mini"
              :item="moderationHeader"
              :is-fixed="true"
              class="black--text"
              :class="colorBackground"
              :is-admin="me.role === 'FOUR_NETWORK'"
            />
          </v-col>
          <v-col cols="1">
            <BaseButton
              type-button="tertiary"
              :svg-icon-name="isExpandedItem(moderationExpanded)"
              class="sidebar-toggle-btn"
            />
          </v-col>
        </v-row>
      </v-list-item>
      <div v-if="moderationExpanded">
        <v-list-item
          :key="key"
          v-for="(item, key) of moderationItems"
          :class="classMiniSidebar"
        >
          <v-row>
            <v-col cols="12" class="py-0">
              <NewSidebarItem
                :mini="mini"
                :item="item"
                @click="updateSelectedItem(item)"
                :class="backgroundSelectedItem(item)"
                :selected="isSeletecItem(item)"
                :is-notification="isNotification"
                :is-message-notification="isMessageNotification"
                :is-image="false"
                :is-admin="me.role === 'FOUR_NETWORK'"
              />
            </v-col>
          </v-row>
        </v-list-item>
      </div>
    </v-list>
    <v-col
      :cols="mini ? '12' : '11'"
      :class="mini ? '' : 'mx-4'"
      v-if="
        me.role === 'FOUR_NETWORK' &&
        userItems.length > 0 &&
        metricsItems.length > 0
      "
    >
      <v-divider />
    </v-col>
    <v-list dense v-if="me.role === 'FOUR_NETWORK' && userItems.length > 0">
      <v-list-item :class="classMiniSidebar">
        <v-row @click="changeExpanded('user')" class="new-sidebar__cursor pr-4">
          <v-col cols="11" class="py-0 d-flex align-center">
            <NewSidebarItem
              :mini="mini"
              :item="userHeader"
              :is-fixed="true"
              class="black--text"
              :class="colorBackground"
              :is-admin="me.role === 'FOUR_NETWORK'"
            />
          </v-col>
          <v-col cols="1">
            <BaseButton
              type-button="tertiary"
              :svg-icon-name="isExpandedItem(userExpanded)"
              class="sidebar-toggle-btn"
            />
          </v-col>
        </v-row>
      </v-list-item>
      <div v-if="userExpanded">
        <v-list-item
          :key="key"
          v-for="(item, key) of userItems"
          :class="classMiniSidebar"
        >
          <v-row>
            <v-col cols="12" class="py-0">
              <NewSidebarItem
                :mini="mini"
                :item="item"
                @click="updateSelectedItem(item)"
                :class="backgroundSelectedItem(item)"
                :selected="isSeletecItem(item)"
                :is-notification="isNotification"
                :is-message-notification="isMessageNotification"
                :is-image="false"
                :is-admin="me.role === 'FOUR_NETWORK'"
              />
            </v-col>
          </v-row>
        </v-list-item>
      </div>
    </v-list>
    <v-col
      :cols="mini ? '12' : '11'"
      :class="mini ? '' : 'mx-4'"
      v-if="me.role === 'MARKETING'"
    >
      <v-divider />
    </v-col>
    <v-list dense v-if="me.role === 'MARKETING'">
      <v-list-item :class="classMiniSidebar">
        <v-row
          @click="changeExpanded('advert')"
          class="new-sidebar__cursor pr-4"
        >
          <v-col cols="11" class="py-0 d-flex align-center">
            <NewSidebarItem
              :mini="mini"
              :item="advertHeader"
              :is-fixed="true"
              class="black--text"
              :class="colorBackground"
              :is-admin="me.role === 'FOUR_NETWORK'"
            />
          </v-col>
          <v-col cols="1">
            <BaseButton
              type-button="tertiary"
              :svg-icon-name="isExpandedItem(advertExpanded)"
              class="sidebar-toggle-btn"
            />
          </v-col>
        </v-row>
      </v-list-item>
      <div v-if="advertExpanded">
        <v-list-item
          :key="key"
          v-for="(item, key) of advertItems"
          :class="classMiniSidebar"
        >
          <v-row>
            <v-col cols="12" class="py-0">
              <NewSidebarItem
                :mini="mini"
                :item="item"
                @click="updateSelectedItem(item)"
                :class="backgroundSelectedItem(item)"
                :selected="isSeletecItem(item)"
                :is-notification="isNotification"
                :is-message-notification="isMessageNotification"
                :is-image="false"
                :is-admin="me.role === 'FOUR_NETWORK'"
              />
            </v-col>
          </v-row>
        </v-list-item>
      </div>
    </v-list>
    <v-col
      cols="12"
      :class="
        me.role !== 'FOUR_NETWORK' && me.role !== 'MARKETING'
          ? mini
            ? 'px-2'
            : ''
          : ''
      "
      class="new-sidebar__border"
    />
    <v-list dense>
      <v-list-item
        :class="classMiniSidebar"
        v-if="
          (me.role !== 'FOUR_NETWORK' &&
            me.role !== 'MARKETING' &&
            (currentUser.role === 'EQUIPE' ||
              currentUser.role === 'EXECUTIVE')) ||
          me.userLogged?.role === 'EQUIPE' ||
          me.userLogged?.role === 'EXECUTIVE'
        "
      >
        <v-row>
          <v-col cols="12" class="py-1">
            <NewSidebarItem
              :mini="mini"
              :item="changeUserItem"
              class="black--text"
              @click="updateSelectedItem(changeUserItem)"
              :class="colorBackground"
              :is-admin="me.role === 'FOUR_NETWORK'"
              :is-user="me.role !== 'FOUR_NETWORK' && me.role !== 'MARKETING'"
            />
          </v-col>
        </v-row>
      </v-list-item>
      <v-list-item
        :class="classMiniSidebar"
        v-if="me.role !== 'FOUR_NETWORK' && me.role !== 'MARKETING'"
      >
        <v-row>
          <v-col cols="12" class="py-1">
            <NewSidebarItem
              :mini="mini"
              :item="transparencyItem"
              @click="updateSelectedItem(transparencyItem)"
              :class="backgroundSelectedItem(transparencyItem)"
              :selected="isSeletecItem(transparencyItem)"
              :is-user="true"
            />
          </v-col>
        </v-row>
      </v-list-item>
      <v-list-item :class="classMiniSidebar">
        <v-row>
          <v-col cols="12" class="py-1">
            <NewSidebarItem
              :mini="mini"
              :item="logoutItem"
              class="black--text"
              @click="updateSelectedItem(logoutItem)"
              :class="colorBackground"
              :is-admin="me.role === 'FOUR_NETWORK'"
              :is-user="me.role !== 'FOUR_NETWORK' && me.role !== 'MARKETING'"
            />
          </v-col>
        </v-row>
      </v-list-item>
    </v-list>
    <div
      :class="[
        'language-selector',
        mini ? 'language-selector--mini' : '',
        classMiniSidebar,
      ]"
    >
      <v-menu
        v-model="languageMenuOpen"
        offset-y
        top
        :nudge-top="4"
        :close-on-content-click="true"
        content-class="language-selector__menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on"
            class="language-selector__activator d-flex align-center"
            :class="mini ? 'justify-center' : ''"
          >
            <v-avatar
              size="24"
              :color="languageAvatarColor"
              class="language-selector__avatar"
              v-if="mini"
            >
              <span :class="languageTextColor" class="label">
                {{ currentLanguageCode }}
              </span>
            </v-avatar>
            <SvgIcon v-else name="translate" color="gray70" />
            <span
              v-show="!mini"
              class="subtitle-1 ml-3 language-selector__label gray70--text"
            >
              {{ currentLanguageLabel }}
            </span>
            <v-spacer v-if="!mini" />
            <SvgIcon
              v-if="!mini"
              :name="languageMenuOpen ? 'arrow_top' : 'arrow'"
              color="gray70"
            />
          </div>
        </template>
        <v-list dense class="language-selector__list pa-0">
          <v-list-item
            v-for="lang in availableLanguages"
            :key="lang.code"
            @click="changeLanguage(lang.code)"
            class="language-selector__list-item"
          >
            <v-list-item-title class="subtitle-1 gray70--text">
              {{ lang.label }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <template
      v-slot:append
      v-if="
        !mini &&
        (me.role === 'MARKETING' ||
          (me.role !== 'FOUR_NETWORK' && me.role !== 'MARKETING'))
      "
    >
      <div class="pa-3" :class="classButton">
        <div v-if="bannerImages.length >= 1" class="banner-fade-carousel">
          <transition-group
            name="banner-fade"
            tag="div"
            class="banner-fade-carousel__wrapper"
            appear
          >
            <template v-for="(item, key) in bannerImages">
              <img
                v-if="currentIndex === key"
                :key="key"
                :src="item.path"
                @click="redirectProfileFourNetwork(key)"
                class="banner-fade-carousel__item"
              />
            </template>
          </transition-group>
        </div>
      </div>
    </template>
  </v-navigation-drawer>
</template>
<script lang="ts">
import i18n from "@/plugins/i18n";
import { TranslateResult } from "vue-i18n";
import { Prop, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import Component, { mixins } from "vue-class-component";
import { ActionMixin } from "../mixins/ActionMixin";
import { TokenService } from "@/api/storage";
import { getLoginRouteFromRole } from "@/mixins/LogoutMixin";
import UserPost from "@/modules/timeline/components/UserPost.vue";
type sidebar_items = {
  name: string | TranslateResult;
  route: string;
  svgIcon?: string;
};
@Component({
  components: {
    UserPost,
  },
})
export default class NewSidebar extends mixins(ActionMixin) {
  @Prop({ default: false }) toggle: boolean;
  @Prop(Boolean) isNotification: boolean;
  @Prop(Boolean) isMessageNotification: boolean;
  selected = null;
  currentIndex = 0;
  bannerCycleInterval: number | null = null;
  generalItemsFourNetwork = [
    {
      name: "Timeline",
      route: "timelineHome",
      permission: "ACCESS_WEB_ADMIN",
      checkPermission: true,
      svgIcon: "timeline",
    },
    {
      name: i18n.t("community.myCommunities"),
      route: "profileCommunity",
      permission: "ACCESS_WEB_ADMIN",
      checkPermission: true,
      svgIcon: "exclusive_lounge",
    },
    {
      name: "Debates",
      route: "roundTableList",
      permission: "ACCESS_WEB_ADMIN",
      checkPermission: true,
      svgIcon: "chat",
    },
    {
      name: i18n.t("readingList.papers"),
      route: "readingListWhitePaperList",
      permission: "ACCESS_WEB_ADMIN",
      checkPermission: true,
      svgIcon: "news",
    },
    {
      name: i18n.t("readingList.successCase"),
      route: "readingListSuccessCase",
      permission: "ACCESS_WEB_ADMIN",
      checkPermission: true,
      svgIcon: "lamp",
    },
    {
      name: i18n.t("profile.messages"),
      route: "chatHome",
      permission: "CHAT_LIST",
      checkPermission: true,
      svgIcon: "e-mail",
    },
    {
      name: i18n.t("notification.title"),
      route: "notificationHome",
      permission: "NOTIFICATION_LIST",
      checkPermission: true,
      svgIcon: "notification_off",
    },
  ];
  generalItemsCompany = [
    {
      name: "Timeline",
      route: "timelineHome",
      svgIcon: "timeline",
    },
    {
      name: i18n.t("community.myCommunities"),
      route: "profileCommunity",
      svgIcon: "exclusive_lounge",
    },
    {
      name: i18n.t("readingList.papers"),
      route: "readingListWhitePaperList",
      svgIcon: "news",
    },
    {
      name: i18n.t("readingList.successCase"),
      route: "readingListSuccessCase",
      svgIcon: "lamp",
    },
    {
      name: i18n.t("readingList.readingList"),
      route: "readingListItems",
      svgIcon: "flag",
    },
    {
      name: i18n.t("profile.messages"),
      route: "chatHome",
      svgIcon: "e-mail",
    },
    {
      name: i18n.t("notification.title"),
      route: "notificationHome",
      svgIcon: "notification_off",
    },
  ];
  generalItemsClevel = [
    {
      name: "Timeline",
      route: "timelineHome",
      svgIcon: "timeline",
    },
    {
      name: i18n.t("community.myCommunities"),
      route: "profileCommunity",
      svgIcon: "exclusive_lounge",
    },
    {
      name: "Debates",
      route: "roundTableList",
      svgIcon: "chat",
    },
    {
      name: i18n.t("readingList.papers"),
      route: "readingListWhitePaperList",
      svgIcon: "news",
    },
    {
      name: i18n.t("readingList.successCase"),
      route: "readingListSuccessCase",
      svgIcon: "lamp",
    },
    {
      name: i18n.t("favorite.favorite"),
      route: "favoritesHome",
      svgIcon: "favorite_lead",
    },
    {
      name: i18n.t("readingList.readingList"),
      route: "readingListItems",
      svgIcon: "flag",
    },
    {
      name: "Exclusive Club",
      route: "exclusiveClub",
      svgIcon: "club",
    },
    {
      name: i18n.t("profile.messages"),
      route: "chatHome",
      svgIcon: "e-mail",
    },
    {
      name: i18n.t("notification.title"),
      route: "notificationHome",
      svgIcon: "notification_off",
    },
  ];
  generalItemsExecutive = [
    {
      name: "Timeline",
      route: "timelineHome",
      svgIcon: "timeline",
    },
    {
      name: i18n.t("community.myCommunities"),
      route: "profileCommunity",
      svgIcon: "exclusive_lounge",
    },
    {
      name: i18n.t("readingList.papers"),
      route: "readingListWhitePaperList",
      svgIcon: "news",
    },
    {
      name: i18n.t("readingList.successCase"),
      route: "readingListSuccessCase",
      svgIcon: "lamp",
    },
    {
      name: "Leads",
      route: "leadsHome",
      svgIcon: "favorite_lead",
    },
    {
      name: i18n.t("readingList.readingListExecutive"),
      route: "readingListItems",
      svgIcon: "flag",
    },
    {
      name: i18n.t("profile.messages"),
      route: "chatHome",
      svgIcon: "e-mail",
    },
    {
      name: i18n.t("notification.title"),
      route: "notificationHome",
      svgIcon: "notification_off",
    },
  ];
  generalItemsPartner = [
    {
      name: "Timeline",
      route: "timelineHome",
      svgIcon: "timeline",
    },
    {
      name: i18n.t("community.myCommunities"),
      route: "profileCommunity",
      svgIcon: "exclusive_lounge",
    },
    {
      name: "Debates",
      route: "roundTableList",
      svgIcon: "chat",
    },
    {
      name: i18n.t("readingList.papers"),
      route: "readingListWhitePaperList",
      svgIcon: "news",
    },
    {
      name: i18n.t("readingList.successCase"),
      route: "readingListSuccessCase",
      svgIcon: "lamp",
    },
    {
      name: i18n.t("favorite.favorite"),
      route: "favoritesHome",
      svgIcon: "favorite_lead",
    },
    {
      name: i18n.t("readingList.readingList"),
      route: "readingListItems",
      svgIcon: "flag",
    },
    {
      name: i18n.t("profile.messages"),
      route: "chatHome",
      svgIcon: "e-mail",
    },
    {
      name: i18n.t("notification.title"),
      route: "notificationHome",
      svgIcon: "notification_off",
    },
  ];
  generalItemsEquipe = [
    {
      name: "Timeline",
      route: "timelineHome",
      svgIcon: "timeline",
    },
    {
      name: i18n.t("community.myCommunities"),
      route: "profileCommunity",
      svgIcon: "exclusive_lounge",
    },
    {
      name: i18n.t("readingList.papers"),
      route: "readingListWhitePaperList",
      svgIcon: "news",
    },
    {
      name: i18n.t("readingList.successCase"),
      route: "readingListSuccessCase",
      svgIcon: "lamp",
    },
    {
      name: i18n.t("readingList.readingList"),
      route: "readingListItems",
      svgIcon: "flag",
    },
    {
      name: i18n.t("profile.messages"),
      route: "chatHome",
      svgIcon: "e-mail",
    },
    {
      name: i18n.t("notification.title"),
      route: "notificationHome",
      svgIcon: "notification_off",
    },
  ];
  metricsCompany = [
    {
      name: i18n.t("settings.metricsGeneral"),
      route: "settingsMetricsCompany",
    },
    {
      name: i18n.t("settings.myAd"),
      route: "settingsMetricsMarketing",
    },
  ];
  metricsFourNetwork = [
    {
      name: i18n.t("settings.metricsGeneral"),
      route: "settingsMetricsGeneral",
      permission: "METRICS_EXCLUSIVE",
      checkPermission: true,
    },
    {
      name: i18n.t("settings.contentFourNetworkProfile"),
      route: "profileHome",
      permission: "PROFILE_ABOUT_UPDATE",
      checkPermission: true,
    },
    {
      name: i18n.t("timeline.posts"),
      route: "settingsMetricsPosts",
      permission: "METRICS_POSTS",
      checkPermission: true,
    },
  ];
  metricsHeaderCompany = {
    name: i18n.t("settings.panel"),
    route: "",
    svgIcon: "configuration_options",
  };
  metricsHeaderFourNetwork = {
    name: i18n.t("settings.panelMetrics"),
    route: "",
    svgIcon: "configuration_options",
  };
  moderationHeader = {
    name: i18n.t("community.moderation"),
    route: "",
    svgIcon: "publish",
  };
  moderationItemsFourNetwork = [
    {
      name: i18n.t("products.sidebar"),
      route: "settingsProductItems",
      permission: "METRICS_POSTS",
      checkPermission: true,
    },
    {
      name: i18n.t("logs.sidebar"),
      route: "settingsLogsItems",
      permission: "USER_ASSIGNED_PERMISSION",
      checkPermission: true,
    },
    {
      name: "Meetings",
      route: "settingsMetricsTransmission",
      permission: "MEETING_MODERATION_LIST",
      checkPermission: true,
    },
    {
      name: i18n.t("survey.title"),
      route: "settingsSurveyItems",
      permission: "METRICS_POSTS",
      checkPermission: true,
    },
    {
      name: i18n.t("settings.fixedContent"),
      route: "settingsFixedPosts",
      permission: "POST_FIX_MODERATION_LIST",
      checkPermission: true,
    },
    {
      name: i18n.t("settings.fixedCompanies"),
      route: "settingsFixedCompanies",
      permission: "FIX_TAG_MODERATION_LIST",
      checkPermission: true,
    },
    {
      name: i18n.t("post.schedules"),
      route: "settingsMetricsSchedulePost",
      permission: "POST_SCHEDULE_LIST",
      checkPermission: true,
    },
    {
      name: i18n.t("settings.advertsing"),
      route: "settingsAdverts",
      permission: "ADVERTISEMENT_MODERATION_LIST",
      checkPermission: true,
    },
    {
      name: i18n.t("misc.interests"),
      route: "settingsInterests",
      permission: "INTEREST_MODERATION_LIST",
      checkPermission: true,
    },
    {
      name: "Debates",
      route: "settingsDebates",
      permission: "DEBATE_MODERATION_LIST",
      checkPermission: true,
    },
    {
      name: i18n.t("settings.denounce"),
      route: "settingsDenunciation",
      permission: "DENUNCIATION_MODERATION_LIST",
      checkPermission: true,
    },
    {
      name: i18n.t("settings.inactivate"),
      route: "settingsInactivates",
      permission: "INACTIVATION_MODERATION_LIST",
      checkPermission: true,
    },
    {
      name: "Lounges",
      route: "settingsCommunities",
      permission: "LOUNGE_MODERATION_LIST",
      checkPermission: true,
    },
  ];
  userHeader = {
    name: i18n.t("search.users"),
    route: "",
    svgIcon: "group_users",
  };
  userItemsFourNetwork = [
    {
      name: i18n.t("users.people"),
      route: "settingsUsersClevel",
      permission: "USER_MODERATION_LIST",
      checkPermission: true,
    },
    {
      name: i18n.t("users.company"),
      route: "settingsUsersMarketing",
      permission: "COMPANY_MODERATION_LIST",
      checkPermission: true,
    },
    {
      name: i18n.t("permission.panel"),
      route: "settingsUsersPermission",
      permission: "USER_ASSIGNED_PERMISSION",
      checkPermission: true,
    },
  ];
  advertHeader = {
    name: i18n.t("settings.panelAd"),
    route: "",
    svgIcon: "money",
  };
  advertItems = [
    {
      name: i18n.t("modal.modalAnnouncementSelected"),
      route: "newAdvert",
    },
    {
      name: i18n.t("settings.pending"),
      route: "settingsAdvertsWaiting",
    },
    {
      name: i18n.t("settings.disapprove"),
      route: "settingsAdvertsDisapproved",
    },
    {
      name: i18n.t("settings.schedule"),
      route: "settingsMetricsSchedulePost",
    },
    {
      name: i18n.t("settings.deleted"),
      route: "settingsAdvertsDeleted",
    },
  ];
  drawer = true;
  filter = "";
  mini = false;
  TokenService = TokenService;
  logoutItem = {
    name: i18n.t("sidebar.logout"),
    route: "loginUserPage",
    svgIcon: "exit",
  };
  changeUserItem = {
    name: i18n.t("sidebar.changeUser"),
    route: "changeUser",
    svgIcon: "refresh",
  };
  transparencyItem = {
    name: i18n.t("transparency.sidebar"),
    route: "transparency",
    svgIcon: "policy_sidebar",
  };
  urls: any = {
    development: "https://dev.exclusivelounge.network",
    staging: "https://staging.exclusivelounge.network",
    production: "https://www.exclusivelounge.network",
  };
  urlsUser: any = {
    development: "https://admin-dev.exclusivelounge.network",
    staging: "https://admin-staging.exclusivelounge.network",
    production: "https://admin.exclusivelounge.network",
  };
  moderationExpanded = false;
  userExpanded = false;
  advertExpanded = false;
  metricsExpanded = false;
  languageMenuOpen = false;
  isTransitioning = false;
  @State((state) => state.profile.me) me: any;
  @State((state) => state.timeline.bannerImages) bannerImages: any;
  @State("moderationIsExpanded") moderationIsExpanded: any;
  @State("userIsExpanded") userIsExpanded: any;
  @State("advertIsExpanded") advertIsExpanded: any;
  @State("metricsIsExpanded") metricsIsExpanded: any;
  @State("currentFilter") currentFilter: any;
  @Action("updateFilter") updateFilter: any;
  @Action("profile/requestUpdateTheme") requestUpdateTheme: any;
  @Action("updateFilterInput") updateFilterInput: any;
  @Action("onboarding/requestLogout") requestLogout: any;
  @Action("onboarding/requestSwitchUserContext") requestSwitchUserContext: any;
  @Action("profile/requestMe") requestMe: any;
  @Action("updateRouteAfterLogin") updateRouteAfterLogin: any;
  @Action("updateMiniSidebarValue") updateMiniSidebarValue: any;
  @Action("profile/requestChangeLanguage") requestChangeLanguage: any;
  @Action("onboarding/storeToken") storeToken: any;
  @Action("updateCurrentTabFourNetwork") updateCurrentTabFourNetwork: any;
  @Action("updateModerationIsExpanded") updateModerationIsExpanded: any;
  @Action("updateUserIsExpanded") updateUserIsExpanded: any;
  @Action("updateAdvertIsExpanded") updateAdvertIsExpanded: any;
  @Action("updateMetricsIsExpanded") updateMetricsIsExpanded: any;
  get userPermissions(): any {
    return TokenService.getRule() || [];
  }
  get classHeader(): string {
    const color = this.me.role === "FOUR_NETWORK" ? "green100" : "gray90";
    const size = this.mini ? "" : "new-sidebar__content";
    return `${color} ${size}`;
  }
  get metricsHeader(): sidebar_items {
    return this.me.role === "MARKETING"
      ? this.metricsHeaderCompany
      : this.metricsHeaderFourNetwork;
  }
  get classMiniSidebar(): string {
    return this.mini ? "px-1" : "px-0";
  }
  get generalItems(): sidebar_items[] {
    if (this.me.role === "MARKETING") {
      return this.generalItemsCompany;
    } else if (this.me.role === "FOUR_NETWORK") {
      return this.generalItemsFourNetwork.filter(
        (item: any) =>
          (item.checkPermission &&
            this.userPermissions.includes(item.permission)) ||
          !item.checkPermission
      );
    } else if (this.me.role === "EQUIPE") {
      return this.generalItemsEquipe;
    } else if (this.me.role === "PARTNER") {
      return this.generalItemsPartner;
    } else if (this.me.role === "EXECUTIVE") {
      return this.generalItemsExecutive;
    } else {
      return this.generalItemsClevel;
    }
  }
  get metricsItems(): sidebar_items[] {
    return this.me.role !== "MARKETING" && this.me.role !== "FOUR_NETWORK"
      ? []
      : this.me.role === "MARKETING"
      ? this.metricsCompany
      : this.metricsFourNetwork.filter(
          (item: any) =>
            (item.checkPermission &&
              this.userPermissions.includes(item.permission)) ||
            !item.checkPermission
        );
  }
  get moderationItems(): sidebar_items[] {
    return this.moderationItemsFourNetwork.filter(
      (item: any) =>
        (item.checkPermission &&
          this.userPermissions.includes(item.permission)) ||
        !item.checkPermission
    );
  }
  get userItems(): sidebar_items[] {
    return this.userItemsFourNetwork.filter(
      (item: any) =>
        (item.checkPermission &&
          this.userPermissions.includes(item.permission)) ||
        !item.checkPermission
    );
  }
  get colorBackground(): string {
    if (this.me.role === "FOUR_NETWORK") {
      return !this.mini ? "white" : "green100 disabled-button-green";
    } else if (this.me.role === "MARKETING") {
      return !this.mini ? "white" : "gray90 disabled-button-gray";
    } else {
      return !this.mini ? "white" : "purple100 disabled-button-gray";
    }
  }
  get currentUser(): any {
    return this.me;
  }
  get classButton(): string {
    return this.$vuetify.breakpoint.mdAndDown ? "button-mobile-responsive" : "";
  }
  get ruleProfile(): boolean {
    return (
      (this.$route.name === "profileHome" && this.me.role === "MARKETING") ||
      (this.$route.name === "timelineFourNetworkSection" &&
        this.me.role === "FOUR_NETWORK")
    );
  }
  created(): void {
    // this.drawer = this.$vuetify.breakpoint.mdAndUp;
    this.filter = this.currentFilter;
    this.moderationExpanded = this.moderationIsExpanded;
    this.userExpanded = this.userIsExpanded;
    this.advertExpanded = this.advertIsExpanded;
    this.metricsExpanded = this.metricsIsExpanded;
  }
  mounted(): void {
    this.updateSelectedItemBasedOnRoute();
    if (this.bannerImages.length > 1) {
      this.bannerCycleInterval = window.setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.bannerImages.length;
      }, 5000);
    }
  }
  @Watch("bannerImages")
  onBannerImagesChange(newVal: any[]): void {
    if (newVal.length > 1 && !this.bannerCycleInterval) {
      this.bannerCycleInterval = window.setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.bannerImages.length;
      }, 5000);
    }
  }
  beforeDestroy(): void {
    if (this.bannerCycleInterval !== null) {
      clearInterval(this.bannerCycleInterval);
    }
  }
  updateSelectedItemBasedOnRoute(): void {
    this.changeUserItem.name =
      this.me.role === "EXECUTIVE"
        ? this.$t("sidebar.changeUserCompany")
        : this.me.role === "EQUIPE"
        ? this.$t("sidebar.changeUserAdmin")
        : this.$t("sidebar.changeUser");
    let currentItem: any;
    this.generalItems.forEach((item: sidebar_items) => {
      let route = this.$route.name;
      if (route?.includes(item.route)) currentItem = item;
    });
    this.metricsItems.forEach((item: sidebar_items) => {
      let route = this.$route.name;
      if (route?.includes(item.route)) currentItem = item;
    });
    if (this.me.role === "FOUR_NETWORK") {
      this.moderationItems.forEach((item: sidebar_items) => {
        let route = this.$route.name;
        if (route?.includes(item.route)) currentItem = item;
      });
      this.userItems.forEach((item: sidebar_items) => {
        let route = this.$route.name;
        if (route?.includes(item.route)) currentItem = item;
      });
    } else if (this.me.role === "MARKETING") {
      this.advertItems.forEach((item: sidebar_items) => {
        let route = this.$route.name;
        if (route?.includes(item.route)) currentItem = item;
      });
    }
    this.selected =
      this.transparencyItem.route === this.$route.name
        ? this.transparencyItem
        : currentItem;
  }
  updateMiniSidebar(): void {
    this.mini = !this.mini;
  }
  isSeletecItem(item: sidebar_items): boolean {
    return this.selected == item;
  }
  async updateSelectedItem(item: any): Promise<void> {
    if (item.route === "changeUser") {
      await this.withLoading(async () => {
        try {
          let userPortalId: number;
          let isCompany: boolean;

          // Se é FOUR_NETWORK ou MARKETING, trocar para pessoa física (userLogged)
          // Endpoint: /user/onboarding/
          if (this.me.role === "FOUR_NETWORK" || this.me.role === "MARKETING") {
            userPortalId = this.me.userLogged.userPortalId;
            isCompany = false; // Trocar para pessoa física
          }
          // Se é pessoa física (EQUIPE/EXECUTIVE), trocar para empresa
          // Endpoint: /company/onboarding/
          else {
            userPortalId = this.me.userPortalId;
            isCompany = true; // Trocar para empresa
          }

          const payload = {
            userPortalId,
            language: this.$root.$i18n.locale,
            isCompany,
          };

          // Trocar contexto de usuário
          await this.requestSwitchUserContext(payload);

          // Forçar reload completo da página para atualizar rules no menu
          window.location.reload();
          // Recarregar dados do perfil
          await this.requestMe();
        } catch (error: any) {
          const messageDefaultTitle = this.$t("toast.error");
          const title = error.response?.data?.title || messageDefaultTitle;
          this.showAlertNotification({
            message: error?.response?.data?.message || this.$t("misc.error"),
            color: "redAlert",
            icon: "cancel",
            title: title,
          });
        }
      });
    } else {
      const newRoute = this.selected === item ? null : item;
      if (newRoute?.route === "loginUserPage") {
        const loginRoute = getLoginRouteFromRole(this.me?.role);
        this.updateRouteAfterLogin({ name: "", params: {} });
        await this.requestLogout();
        this.$router.push({ name: loginRoute });
        return;
      }
      if (newRoute) this.$router.push({ name: newRoute.route });
    }
  }
  backgroundSelectedItem(item: sidebar_items): string {
    return this.isSeletecItem(item)
      ? `purple100--text ${this.colorBackground}`
      : `gray70--text ${this.colorBackground}`;
  }
  async updateTheme(item: boolean): Promise<void> {
    const payload = {
      theme: item ? "DARK" : "LIGHT",
    };
    await this.withLoading(async () => {
      await this.requestUpdateTheme(payload);
    });
  }
  redirectSearch(): void {
    if (this.$route.name !== "searchHome")
      this.$router.push({ name: "searchHome" });
  }
  redirectProfile(): void {
    if (
      this.$route.name !== "timelineFourNetworkSection" &&
      this.me.role === "FOUR_NETWORK"
    )
      this.$router.push({ name: "timelineFourNetworkSection" });
    if (
      this.$route.name !== "profileHome" &&
      (this.me.role === "MARKETING" ||
        (this.me.role !== "FOUR_NETWORK" && this.me.role !== "MARKETING"))
    )
      this.$router.push({ name: "profileHome" });
  }
  redirectProfileFourNetwork(key: number): void {
    if (this.$route.name !== "timelineFourNetworkSection")
      this.$router.push({
        name: "timelineFourNetworkSection",
      });
    this.updateCurrentTabFourNetwork(key);
  }
  updateStoreFilter(): void {
    if (!this.filter) return;
    this.updateFilter(!this.filter ? "" : this.filter);
    if (
      this.$vuetify.breakpoint.mdAndDown &&
      this.$route.name === "searchHome"
    ) {
      this.drawer = false;
    }
    this.redirectSearch();
  }
  clearStoreFilter(): void {
    this.filter = "";
    this.updateFilter(!this.filter ? "" : this.filter);
    this.redirectSearch();
  }
  miniSidebar(): void {
    this.metricsExpanded = false;
    this.moderationExpanded = false;
    this.userExpanded = false;
    this.advertExpanded = false;
    this.updateMetricsIsExpanded(this.metricsExpanded);
    this.updateModerationIsExpanded(this.moderationExpanded);
    this.updateUserIsExpanded(this.userExpanded);
    this.updateAdvertIsExpanded(this.advertExpanded);
    this.isTransitioning = true;
    this.$nextTick(() => {
      this.mini = !this.mini;
      setTimeout(() => {
        this.isTransitioning = false;
      }, 300);
    });
  }
  isExpandedItem(value: boolean): string {
    return value ? "arrow_top" : "arrow";
  }
  changeExpanded(type: string): void {
    if (type === "metrics") {
      this.metricsExpanded = !this.metricsExpanded;
      this.updateMetricsIsExpanded(this.metricsExpanded);
    }
    if (type === "moderation") {
      this.moderationExpanded = !this.moderationExpanded;
      this.updateModerationIsExpanded(this.moderationExpanded);
    }
    if (type === "user") {
      this.userExpanded = !this.userExpanded;
      this.updateUserIsExpanded(this.userExpanded);
    }
    if (type === "advert") {
      this.advertExpanded = !this.advertExpanded;
      this.updateAdvertIsExpanded(this.advertExpanded);
    }
  }
  get currentLanguageCode(): string {
    const lang = TokenService.getLanguage() || this.$root.$i18n.locale || "pt";
    return lang.toUpperCase();
  }
  get languageOptions(): any[] {
    return [
      { code: "pt", label: this.$t("misc.portuguese") },
      { code: "en", label: this.$t("misc.english") },
      { code: "es", label: this.$t("misc.spanish") },
    ];
  }
  get currentLanguageLabel(): string {
    const lang = (
      TokenService.getLanguage() ||
      this.$root.$i18n.locale ||
      "pt"
    ).toLowerCase();
    const found = this.languageOptions.find((l: any) => l.code === lang);
    return found ? found.label : (this.$t("misc.portuguese") as string);
  }
  get availableLanguages(): any[] {
    const currentLang = (
      TokenService.getLanguage() ||
      this.$root.$i18n.locale ||
      "pt"
    ).toLowerCase();
    return this.languageOptions.filter((l: any) => l.code !== currentLang);
  }
  get languageAvatarColor(): string {
    if (this.me.role === "FOUR_NETWORK" || this.me.role === "MARKETING") {
      return "purple100";
    }
    return this.mini ? "white" : "purple100";
  }
  get languageTextColor(): string {
    if (this.me.role === "FOUR_NETWORK" || this.me.role === "MARKETING") {
      return "white--text";
    }
    return this.mini ? "purple100--text" : "white--text";
  }
  get arrowColor(): string {
    if (this.me.role === "FOUR_NETWORK" || this.me.role === "MARKETING") {
      return (this.$route.name === "timelineFourNetworkSection" &&
        this.me.role === "FOUR_NETWORK") ||
        (this.$route.name === "profileHome" && this.me.role === "MARKETING") ||
        this.$vuetify.breakpoint.mdAndDown
        ? "white"
        : "purple100";
    } else {
      return this.$route.name === "profileHome" ||
        this.$vuetify.breakpoint.mdAndDown
        ? "white"
        : "purple100";
    }
  }
  redirectTimeline(): void {
    if (this.$route.name !== "timelineHome")
      this.$router.push({ name: "timelineHome" });
  }
  @Watch("$route")
  onRouteChanged(): void {
    this.updateSelectedItemBasedOnRoute();
  }
  @Watch("toggle", { immediate: true }) onItemChanged(): void {
    if (this.$vuetify.breakpoint.lgAndDown) this.drawer = this.toggle;
  }
  @Watch("filter", { immediate: true, deep: true })
  updateValueFilter(): void {
    this.updateFilterInput(!this.filter ? "" : this.filter);
  }
  @Watch("mini") onMiniChanged(): void {
    this.updateMiniSidebarValue(this.mini);
  }
  @Watch("$vuetify.breakpoint.lgAndUp") onBreakpointChanged(
    newVal: boolean
  ): void {
    // Quando a tela ficar menor que lg, resetar mini para false e fechar drawer
    if (!newVal) {
      if (this.mini) {
        this.mini = false;
      }
      // Fechar drawer para evitar overlay quando redimensiona de lg para md/menor
      this.drawer = false;
    }
  }
  @Watch("me", { deep: true })
  onUserDataChanged(): void {
    // Atualizar item selecionado quando dados do usuário mudarem
    if (this.me && this.me.role) {
      this.updateSelectedItemBasedOnRoute();
    }
  }
  async changeLanguage(langCode: string): Promise<void> {
    await this.withLoading(async () => {
      const refreshToken = TokenService.getRefreshToken();
      const data = await this.requestChangeLanguage({
        language: langCode.toUpperCase(),
        refreshToken: refreshToken,
      });
      this.storeToken(data);
      this.$root.$i18n.locale = langCode;
      this.$root.$i18n.fallbackLocale = langCode;
      TokenService.saveLanguage(langCode);
      window.location.reload();
    });
  }
}
</script>
<style lang="sass">
.new-sidebar__
  &border
    border-bottom: 1px solid var(--v-gray15-base)
  &cursor
    cursor: pointer
  &border-responsive
    border-bottom: 1px solid var(--v-purpleSidebar-base)
    background-color: var(--v-purple100-base)
  &content
    height: 68px !important

// Solução completa para o problema da barra de rolagem
.new-sidebar
  &.purple100 .v-navigation-drawer__content
    background-color: var(--v-purple100-base) !important

  &.green100 .v-navigation-drawer__content
    background-color: var(--v-green100-base) !important

  &.gray90 .v-navigation-drawer__content
    background-color: var(--v-gray90-base) !important

  &.white .v-navigation-drawer__content
    background-color: white !important

  // Remover completamente qualquer espaço para a barra de rolagem
  .v-navigation-drawer__content
    overflow-y: scroll !important
    overflow-x: hidden !important
    scrollbar-width: none !important
    -ms-overflow-style: none !important
    box-sizing: border-box !important
    width: 100% !important
    max-width: 100% !important
    padding-right: 0 !important
    margin-right: 0 !important
    right: 0 !important

    // Adicionar padding-bottom em mobile para evitar que botão de logout fique inacessível
    @media (max-width: 1264px)
      padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important

    &::-webkit-scrollbar
      width: 0 !important
      height: 0 !important
      display: none !important
      background-color: transparent !important

  // Garantir que todos os elementos internos ocupem a largura total
  .v-list
    padding-right: 0 !important
    width: 100% !important
    max-width: 100% !important
    box-sizing: border-box !important

  .v-list-item
    padding-right: 0 !important
    margin-right: 0 !important
    width: 100% !important
    max-width: 100% !important
    box-sizing: border-box !important

  // Forçar o conteúdo a ocupar toda a largura disponível
  .v-list-item__content
    width: 100% !important
    max-width: 100% !important
    box-sizing: border-box !important

  // Ajustar o layout para evitar o espaço da barra de rolagem
  .v-list-item__action:last-of-type
    margin-right: 0 !important
    padding-right: 0 !important

.theme--light.v-btn.v-btn--disabled.disabled-button-gray, .theme--light.v-btn.disabled-button-gray.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn-outlined), .theme--light.v-btn.disabled-button-gray.v-btn--disabled.v-btn--has-bg
  background: var(--v-gray90-base) !important
.theme--light.v-btn.v-btn--disabled.disabled-button-green, .theme--light.v-btn.disabled-button-green.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn-outlined), .theme--light.v-btn.disabled-button-green.v-btn--disabled.v-btn--has-bg
  background: var(--v-green100-base) !important

.sidebar-toggle-btn
  width: 36px !important
  height: 36px !important
  min-width: 36px !important
  max-width: 36px !important
  padding: 0 !important
  border-radius: 50% !important

  .mr-1
    margin-right: 0 !important

.banner-fade-carousel
  position: relative
  height: 100px
  overflow: hidden
  &__wrapper
    position: relative
    height: 100%
  &__item
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    object-fit: cover
    cursor: pointer

.banner-fade-enter-active,
.banner-fade-leave-active
  transition: opacity 0.8s ease

.banner-fade-enter,
.banner-fade-leave-to
  opacity: 0

.sidebar-transition-overlay
  position: absolute
  top: 0
  left: 0
  right: 0
  bottom: 0
  z-index: 10
  background: transparent

.new-sidebar--transitioning .new-sideber-item
  transition: none !important

.new-sidebar--transitioning .v-list-item
  transition: none !important

.button-mobile-responsive
  @media (max-width: 1449px)
    margin-bottom: 70px
    padding-bottom: 10px

.language-selector
  padding: 0
  cursor: pointer
  &--mini
    padding: 0 4px
  &__activator
    padding: 8px 16px
    margin-left: -4px
    border-radius: 8px
    cursor: pointer
    transition: background-color 0.2s
    &:hover
      background-color: rgba(0, 0, 0, 0.04)
  &__avatar
    flex-shrink: 0
  &__label
    line-height: 1.5 !important
  &__list
    border-radius: 8px !important
    overflow: hidden
    .v-list-item__title
      line-height: 1.5 !important
  &__list-item
    cursor: pointer
    min-height: 40px
    &:hover
      background-color: rgba(0, 0, 0, 0.04)
  &__menu
    border-radius: 8px !important
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important
</style>
